import React from 'react';

export default function WrapFragment(props) {
  const { children } = props;
  return <>{children}</>;
}
